
import { defineComponent } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ECP_EDP_DashboardNavigator from "@/components/cards/ECP_EDP_DashboardNavigator.vue";
import RecentActivityCard from "@/components/dashboard/sequence/RecentActivityCard.vue";
import { getDashboardData } from "@/api/dashboard";

export default defineComponent({
  name: "RecentActivity",
  components: {
    ECP_EDP_DashboardNavigator,
    RecentActivityCard,
  },
  data() {
    return {
      pt: "",
      currencySymbol: "",
    };
  },
  mounted() {
    setCurrentPageTitle("Recent Activity");
    this.pt = String(localStorage.getItem("pt"));
    this.loadCurrency();
  },
  methods: {
    async loadCurrency() {
      try {
        const response = await getDashboardData();
        this.currencySymbol = response?.data?.currency ?? "";
      } catch (error) {
        console.error("Failed to load currency for recent activity:", error);
      }
    },
  },
});
